import { IconProps } from '.';

const SortIcon = ({
  color = 'var(--color-ui-stroke-primary',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        className={customClasses}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.445 13.0045L16 19.115L21.5549 13.0045L20.445 11.9955L16.7502 16.0598L16.7502 4.99976L15.2502 4.99976L15.2502 16.0604L11.5549 11.9955L10.445 13.0045ZM5.25024 3.9407L5.25024 15.0007L6.75024 15.0007L6.75024 3.94011L10.4456 8.00496L11.5555 6.99595L6.00051 0.885499L0.445556 6.99595L1.55547 8.00496L5.25024 3.9407Z"
        fill={color}
      />
    </svg>
  );
};

export default SortIcon;
